import { moviesLoaded, moviesLoading, moviesLoadingFailed } from './actionCreators'
import { ThunkFunction } from '../models'
import { getMediaItems } from '../../services/mediaItems'

export const loadMovies = (): ThunkFunction<Promise<void>> => async (dispatch, getState) => {
  const { status } = getState().movies

  if (status !== 'loaded' && status !== 'loading') {
    dispatch(moviesLoading())
    try {
      const items = await getMediaItems()
      dispatch(moviesLoaded(items))
    } catch (e) {
      dispatch(moviesLoadingFailed())
    }
  }
}
